module.exports = __webpack_public_path__ + "static/media/women-watch.bee8c68a.jpeg";